import { enableProdMode, provideZoneChangeDetection, type Provider } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { Auth } from '@angular/fire/auth';
import { FirebaseApp } from '@angular/fire/app';

import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import { AppInjector } from '@shared/injectors/app.injector';

if (environment.production) {
  enableProdMode();
}

/**
 * initializeApp/getAuth must come from the app's `firebase` package (v9).
 * `@angular/fire/app` re-exports can bind to the nested firebase@12 under
 * @angular/fire, which yields "Component auth has not been registered yet"
 * when getAuth runs on a different SDK copy than initializeApp.
 */
const firebaseProviders: Provider[] = [
  {
    provide: FirebaseApp,
    useFactory: (): FirebaseApp =>
      (getApps().length > 0 ? getApp() : initializeApp(environment.api.firebase)) as FirebaseApp,
  },
  {
    provide: Auth,
    deps: [FirebaseApp],
    useFactory: (app: FirebaseApp): Auth => getAuth(app) as Auth,
  },
];

platformBrowser()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection(), ...firebaseProviders],
  })
  .then(moduleRef => AppInjector.setInjector(moduleRef.injector))
  .catch(err => console.log(err));
